import { useEffect } from 'react';
import { Navigate, Routes } from 'react-router-dom';

import { useAuth } from './core/Auth';

export function Logout() {
  const { logout } = useAuth();
  useEffect(() => {
    // Await so the reload doesn't fire (and potentially abort the in-flight revoke request)
    // before logout() has actually finished revoking the refresh token server-side.
    logout().finally(() => {
      document.location.reload();
    });
  }, [logout]);

  return (
    <Routes>
      <Navigate to="/login" />
    </Routes>
  );
}
